import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';

const fetchOpportunities = async (authenticatedFetch, params) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL || '/api'}/opportunities?${queryString}`);
  
  if (!response.ok) {
    throw new Error('Failed to fetch opportunities');
  }
  
  return response.json();
};

export const useOpportunities = (params = {}) => {
  const { authenticatedFetch } = useAuthenticatedApi();
  
  return useQuery({
    queryKey: ['opportunities', params],
    queryFn: () => fetchOpportunities(authenticatedFetch, params),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error) => {
      // Keep retrying if it's a network/server error, but not for auth errors
      if (error?.message?.includes('Failed to fetch opportunities')) {
        return failureCount < 10; // Retry up to 10 times for server errors
      }
      return false; // Don't retry for other errors
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    enabled: !!authenticatedFetch, // Only run when authenticated
    refetchOnMount: true,
  });
};